module.exports = __webpack_public_path__ + "static/media/lifeaddwiser.974550c7.png";